module.exports = __webpack_public_path__ + "static/media/PIBKG_yellow.9e79262b.png";